/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root';
import { Route as IndexRouteImport } from './routes/index';
import { Route as ArenaRouteImport } from './routes/arena';
import { Route as BreakRouteImport } from './routes/break';
import { Route as LoginRouteImport } from './routes/login';
import { Route as ModesRouteImport } from './routes/modes';
import { Route as ParentRouteImport } from './routes/parent';
import { Route as ParentIndexRouteImport } from './routes/parent.index';
import { Route as ParentMistakesRouteImport } from './routes/parent.mistakes';
import { Route as ParentReviewRouteImport } from './routes/parent.review';
import { Route as ParentSettingsRouteImport } from './routes/parent.settings';
import { Route as ParentSkillsRouteImport } from './routes/parent.skills';
import { Route as ParentWalletRouteImport } from './routes/parent.wallet';
import { Route as PlaySessionIdRouteImport } from './routes/play.$sessionId';
import { Route as SummarySessionIdRouteImport } from './routes/summary.$sessionId';

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any);
const ArenaRoute = ArenaRouteImport.update({
  id: '/arena',
  path: '/arena',
  getParentRoute: () => rootRouteImport,
} as any);
const BreakRoute = BreakRouteImport.update({
  id: '/break',
  path: '/break',
  getParentRoute: () => rootRouteImport,
} as any);
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any);
const ModesRoute = ModesRouteImport.update({
  id: '/modes',
  path: '/modes',
  getParentRoute: () => rootRouteImport,
} as any);
const ParentRoute = ParentRouteImport.update({
  id: '/parent',
  path: '/parent',
  getParentRoute: () => rootRouteImport,
} as any);
const ParentIndexRoute = ParentIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ParentRoute,
} as any);
const ParentMistakesRoute = ParentMistakesRouteImport.update({
  id: '/mistakes',
  path: '/mistakes',
  getParentRoute: () => ParentRoute,
} as any);
const ParentReviewRoute = ParentReviewRouteImport.update({
  id: '/review',
  path: '/review',
  getParentRoute: () => ParentRoute,
} as any);
const ParentSettingsRoute = ParentSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => ParentRoute,
} as any);
const ParentSkillsRoute = ParentSkillsRouteImport.update({
  id: '/skills',
  path: '/skills',
  getParentRoute: () => ParentRoute,
} as any);
const ParentWalletRoute = ParentWalletRouteImport.update({
  id: '/wallet',
  path: '/wallet',
  getParentRoute: () => ParentRoute,
} as any);
const PlaySessionIdRoute = PlaySessionIdRouteImport.update({
  id: '/play/$sessionId',
  path: '/play/$sessionId',
  getParentRoute: () => rootRouteImport,
} as any);
const SummarySessionIdRoute = SummarySessionIdRouteImport.update({
  id: '/summary/$sessionId',
  path: '/summary/$sessionId',
  getParentRoute: () => rootRouteImport,
} as any);

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute;
  '/arena': typeof ArenaRoute;
  '/break': typeof BreakRoute;
  '/login': typeof LoginRoute;
  '/modes': typeof ModesRoute;
  '/parent': typeof ParentRouteWithChildren;
  '/parent/mistakes': typeof ParentMistakesRoute;
  '/parent/review': typeof ParentReviewRoute;
  '/parent/settings': typeof ParentSettingsRoute;
  '/parent/skills': typeof ParentSkillsRoute;
  '/parent/wallet': typeof ParentWalletRoute;
  '/play/$sessionId': typeof PlaySessionIdRoute;
  '/summary/$sessionId': typeof SummarySessionIdRoute;
  '/parent/': typeof ParentIndexRoute;
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute;
  '/arena': typeof ArenaRoute;
  '/break': typeof BreakRoute;
  '/login': typeof LoginRoute;
  '/modes': typeof ModesRoute;
  '/parent/mistakes': typeof ParentMistakesRoute;
  '/parent/review': typeof ParentReviewRoute;
  '/parent/settings': typeof ParentSettingsRoute;
  '/parent/skills': typeof ParentSkillsRoute;
  '/parent/wallet': typeof ParentWalletRoute;
  '/play/$sessionId': typeof PlaySessionIdRoute;
  '/summary/$sessionId': typeof SummarySessionIdRoute;
  '/parent': typeof ParentIndexRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  '/': typeof IndexRoute;
  '/arena': typeof ArenaRoute;
  '/break': typeof BreakRoute;
  '/login': typeof LoginRoute;
  '/modes': typeof ModesRoute;
  '/parent': typeof ParentRouteWithChildren;
  '/parent/mistakes': typeof ParentMistakesRoute;
  '/parent/review': typeof ParentReviewRoute;
  '/parent/settings': typeof ParentSettingsRoute;
  '/parent/skills': typeof ParentSkillsRoute;
  '/parent/wallet': typeof ParentWalletRoute;
  '/play/$sessionId': typeof PlaySessionIdRoute;
  '/summary/$sessionId': typeof SummarySessionIdRoute;
  '/parent/': typeof ParentIndexRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | '/'
    | '/arena'
    | '/break'
    | '/login'
    | '/modes'
    | '/parent'
    | '/parent/mistakes'
    | '/parent/review'
    | '/parent/settings'
    | '/parent/skills'
    | '/parent/wallet'
    | '/play/$sessionId'
    | '/summary/$sessionId'
    | '/parent/';
  fileRoutesByTo: FileRoutesByTo;
  to:
    | '/'
    | '/arena'
    | '/break'
    | '/login'
    | '/modes'
    | '/parent/mistakes'
    | '/parent/review'
    | '/parent/settings'
    | '/parent/skills'
    | '/parent/wallet'
    | '/play/$sessionId'
    | '/summary/$sessionId'
    | '/parent';
  id:
    | '__root__'
    | '/'
    | '/arena'
    | '/break'
    | '/login'
    | '/modes'
    | '/parent'
    | '/parent/mistakes'
    | '/parent/review'
    | '/parent/settings'
    | '/parent/skills'
    | '/parent/wallet'
    | '/play/$sessionId'
    | '/summary/$sessionId'
    | '/parent/';
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  ArenaRoute: typeof ArenaRoute;
  BreakRoute: typeof BreakRoute;
  LoginRoute: typeof LoginRoute;
  ModesRoute: typeof ModesRoute;
  ParentRoute: typeof ParentRouteWithChildren;
  PlaySessionIdRoute: typeof PlaySessionIdRoute;
  SummarySessionIdRoute: typeof SummarySessionIdRoute;
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/';
      path: '/';
      fullPath: '/';
      preLoaderRoute: typeof IndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/arena': {
      id: '/arena';
      path: '/arena';
      fullPath: '/arena';
      preLoaderRoute: typeof ArenaRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/break': {
      id: '/break';
      path: '/break';
      fullPath: '/break';
      preLoaderRoute: typeof BreakRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/login': {
      id: '/login';
      path: '/login';
      fullPath: '/login';
      preLoaderRoute: typeof LoginRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/modes': {
      id: '/modes';
      path: '/modes';
      fullPath: '/modes';
      preLoaderRoute: typeof ModesRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/parent': {
      id: '/parent';
      path: '/parent';
      fullPath: '/parent';
      preLoaderRoute: typeof ParentRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/parent/': {
      id: '/parent/';
      path: '/';
      fullPath: '/parent/';
      preLoaderRoute: typeof ParentIndexRouteImport;
      parentRoute: typeof ParentRoute;
    };
    '/parent/mistakes': {
      id: '/parent/mistakes';
      path: '/mistakes';
      fullPath: '/parent/mistakes';
      preLoaderRoute: typeof ParentMistakesRouteImport;
      parentRoute: typeof ParentRoute;
    };
    '/parent/review': {
      id: '/parent/review';
      path: '/review';
      fullPath: '/parent/review';
      preLoaderRoute: typeof ParentReviewRouteImport;
      parentRoute: typeof ParentRoute;
    };
    '/parent/settings': {
      id: '/parent/settings';
      path: '/settings';
      fullPath: '/parent/settings';
      preLoaderRoute: typeof ParentSettingsRouteImport;
      parentRoute: typeof ParentRoute;
    };
    '/parent/skills': {
      id: '/parent/skills';
      path: '/skills';
      fullPath: '/parent/skills';
      preLoaderRoute: typeof ParentSkillsRouteImport;
      parentRoute: typeof ParentRoute;
    };
    '/parent/wallet': {
      id: '/parent/wallet';
      path: '/wallet';
      fullPath: '/parent/wallet';
      preLoaderRoute: typeof ParentWalletRouteImport;
      parentRoute: typeof ParentRoute;
    };
    '/play/$sessionId': {
      id: '/play/$sessionId';
      path: '/play/$sessionId';
      fullPath: '/play/$sessionId';
      preLoaderRoute: typeof PlaySessionIdRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/summary/$sessionId': {
      id: '/summary/$sessionId';
      path: '/summary/$sessionId';
      fullPath: '/summary/$sessionId';
      preLoaderRoute: typeof SummarySessionIdRouteImport;
      parentRoute: typeof rootRouteImport;
    };
  }
}

interface ParentRouteChildren {
  ParentMistakesRoute: typeof ParentMistakesRoute;
  ParentReviewRoute: typeof ParentReviewRoute;
  ParentSettingsRoute: typeof ParentSettingsRoute;
  ParentSkillsRoute: typeof ParentSkillsRoute;
  ParentWalletRoute: typeof ParentWalletRoute;
  ParentIndexRoute: typeof ParentIndexRoute;
}

const ParentRouteChildren: ParentRouteChildren = {
  ParentMistakesRoute: ParentMistakesRoute,
  ParentReviewRoute: ParentReviewRoute,
  ParentSettingsRoute: ParentSettingsRoute,
  ParentSkillsRoute: ParentSkillsRoute,
  ParentWalletRoute: ParentWalletRoute,
  ParentIndexRoute: ParentIndexRoute,
};

const ParentRouteWithChildren =
  ParentRoute._addFileChildren(ParentRouteChildren);

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ArenaRoute: ArenaRoute,
  BreakRoute: BreakRoute,
  LoginRoute: LoginRoute,
  ModesRoute: ModesRoute,
  ParentRoute: ParentRouteWithChildren,
  PlaySessionIdRoute: PlaySessionIdRoute,
  SummarySessionIdRoute: SummarySessionIdRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
